// LES UNITES DE STOCK, DEFINIES UNE SEULE FOIS (28/09/2026).
//
// Elles l'etaient DEUX fois -- `pages/Stock.js` et `components/Reference-
// sVehicule.js` -- et s'affichaient telles qu'elles sont STOCKEES : « 4 piece »,
// « 2 metre ». Releve par l'audit du 21/08 (B3). C'est la meme famille que la
// liste des roles recopiee dans deux ecrans (carnet, entree 62) : une liste en
// deux exemplaires finit par diverger.
//
// LA VALEUR NE CHANGE PAS, seul l'affichage change. `piece` reste ce qui est
// enregistre en base : les articles existants n'ont pas a etre repris, et la
// valeur sans accent reste sure dans un export ou une URL.
export const UNITES = [
  { valeur: "piece", singulier: "pièce", pluriel: "pièces" },
  { valeur: "litre", singulier: "litre", pluriel: "litres" },
  { valeur: "kg", singulier: "kg", pluriel: "kg" },
  { valeur: "metre", singulier: "mètre", pluriel: "mètres" },
  { valeur: "jeu", singulier: "jeu", pluriel: "jeux" },
  { valeur: "bidon", singulier: "bidon", pluriel: "bidons" },
];

/** « 1 pièce », « 4 pièces », « 1,5 litre » : le pluriel commence a 2.
 *
 * Une unite inconnue (saisie ancienne, import) est rendue telle quelle
 * plutot que masquee : une quantite sans unite se lirait comme des pieces. */
export function libelleUnite(unite, quantite) {
  const u = UNITES.find((x) => x.valeur === unite);
  if (!u) return unite || "";
  const n = Math.abs(Number(quantite));
  return Number.isFinite(n) && n >= 2 ? u.pluriel : u.singulier;
}
